export default __webpack_public_path__ + "img/list0.12ac608c.jpg";